import React, { useState, useEffect } from 'react';
import '../Admin.css'; // Import CSS for styling
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { adminResetpassword } from '../../../services/CommonService';
import { useAuth } from '../../../Utils/AuthProvider'
import Swal from "sweetalert2";


function ForgetPassword() {
    const [otp, setOtp] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const { setAuthToken } = useAuth();
    const [showPassword, setShowPassword] = useState(false);

    const location = useLocation();
    const email = location.state?.email;

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleotpChange = (event) => {
        setOtp(event.target.value);
    };

    useEffect(() => {
        if (confirmPassword && password !== confirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError('');
        }
    }, [password, confirmPassword]);

    const handleLogin = async (event) => {
        event.preventDefault();
        setError('');

        try {
            const forgetData = {
                email: email,
                otp: otp,
                password: password,
                password_confirmation: confirmPassword
            }
            let response;
            response = await adminResetpassword(forgetData);
            if (response.status == 200) {
                Swal.fire({
                    title: "Success",
                    text: "Password Changed successfully",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            setError('Failed to connect to the server.');
              Swal.fire({
                    title: "Error",
                    text: error?.response?.data?.message || error?.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            if (error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message); // Display server-specific error
            }
        }
    };

    return (
        <div className="admin-login-container">
            <h2>Forget Password</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleLogin}>
                <div className="form-group" style={{ position: 'relative' }}>
                    <label htmlFor="otp">Otp:</label>
                    <input
                        type="text"
                        id="otp"
                        value={otp}
                        onChange={handleotpChange}
                        required
                    />
                </div>
                <div className="form-group" style={{ position: 'relative' }}>
                    <label htmlFor="password"> New Password:</label>
                    <input
                        type="password"
                        placeholder="New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group" style={{ position: 'relative' }}>
                    <label htmlFor="Cpassword">Confirm Password:</label>
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    {passwordError && (
                        <div style={{ color: 'red', marginTop: '5px' }}>{passwordError}</div>
                    )}
                </div>

                <button type="submit" className="login-button w-100">Login</button>
            </form>
            {/* <div className="mt-3 text-center">
        <span style={{ fontSize: 'small' }}>
          Don’t have an account?{" "}
          <Link to="/admin/register">Register here</Link>
        </span>
      </div> */}


        </div>
    );
}

export default ForgetPassword;